import { SelectionPage } from "../basic/selection-page";
import { ChatSection } from "../operations/chat-section";
import { NewsSection } from "../operations/news-section";
import { ZoomSection } from "../operations/zoom-section";
import { MusicSectionListing } from "../operations/music-section-listing";
import { MediaSection } from "../operations/media-section";
import { HealthSectionListing } from "../operations/health-section-listing";
import { GPTSection } from "../operations/gpt-section";
import { RobotStreamSection } from "../operations/robot-stream-section";
import { GameTicTacToeSection } from "../operations/game-tic-tac-toe";
import { GameWesternChessSection } from "../operations/game-western-chess";
import { GameChineseChessSection } from "../operations/game-chinese-chess";
import { TestingSection } from "../operations/testing-section";

import { CardFlipGame } from "../games/card-flip-game";
import { RecyclingGame } from "../games/recycling-game";

import {
  AttachFile,
  Adb,
  AddIcCall,
  HealthAndSafety,
  LibraryMusic,
  Newspaper,
  Summarize,
} from "@mui/icons-material";

const routes = [
  {
    name: "Main",
    key: "selection-page",
    // icon: <LibraryMusic />,
    route: "/",
    component: <SelectionPage />,
  },
  {
    name: "MusicListing",
    key: "music-section-listing",
    icon: <LibraryMusic />,
    route: "/operation/music-section-listing",
    component: <MusicSectionListing />,
  },
  {
    name: "Media",
    key: "media-section",
    icon: <LibraryMusic />,
    route: "/operation/media-section",
    component: <MediaSection />,
  },
  {
    name: "News",
    key: "news-section",
    icon: <Newspaper />,
    route: "/operation/news-section",
    component: <NewsSection />,
  },
  {
    name: "Health Info",
    key: "health-section-listing",
    icon: <HealthAndSafety />,
    route: "/operation/health-section-listing",
    component: <HealthSectionListing />,
  },
  {
    name: "Tic Tac Toe",
    key: "game-tic-tac-toe-section",
    route: "/operation/game-tic-tac-toe-section",
    component: <GameTicTacToeSection />,
  },
  {
    name: "Western Chess",
    key: "game-western-chess-section",
    route: "/operation/game-western-chess-section",
    component: <GameWesternChessSection />,
  },
  {
    name: "Chinese Chess",
    key: "game-chinese-chess-section",
    route: "/operation/game-chinese-chess-section",
    component: <GameChineseChessSection />,
  },
  {
    name: "Testing",
    key: "testing",
    route: "/operation/testing",
    component: <TestingSection />,
  },
  //   name: "GPT",
  //   key: "gpt-section",
  //   icon: <Newspaper />,
  //   route: "/operation/gpt-section",
  //   component: <GPTSection />,
  // },
  // {
  //   name: "GPT",
  //   key: "robot-stream-section",
  //   icon: <Newspaper />,
  //   route: "/operation/robot-stream-section",
  //   component: <RobotStreamSection />,
  // },
  // {
  //   name: "Zoom",
  //   key: "zoom-section",
  //   icon: <Adb />,
  //   route: "/operation/zoom-section",
  //   component: <ZoomSection />,
  // },
  {
    name: "Chat",
    key: "chat-section",
    icon: <Summarize />,
    route: "/operation/chat-section",
    component: <ChatSection />,
  },

  {
    name: "CardFlip",
    key: "card-flip-game",
    icon: <Summarize />,
    route: "/games/card-flip-game",
    component: <CardFlipGame />,
  },
  {
    name: "RecyclingGame",
    key: "recycling-game",
    icon: <Summarize />,
    route: "/games/recycling-game",
    component: <RecyclingGame />,
  },
];

export default routes;
